import React from 'react';
import Adnavbar from './Adnavbar';
import Dashboard from './Dashboard';
import Footer from '../components/Footer';

// import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

const About = () => {
    return (
      <>
          <Adnavbar />
          <Dashboard />
          <Footer />
      </>
    )
}

export default About
